var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#02d17b}")), /*#__PURE__*/React.createElement("path", {
    d: "M3.4 23.9V13.5c0-1.1.5-1.8 1.4-2.3l5.7-3.3c2-1.2 4.1-2.4 6.1-3.6 2-1.1 3.9-2.3 5.9-3.4.8-.5 1.7-.6 2.5-.1 1.8 1 3.6 2.1 5.5 3.1 2.2 1.3 4.4 2.6 6.7 3.9 2 1.2 4 2.3 6 3.5.9.5 1.3 1.3 1.3 2.3V34c0 1.2-.4 2-1.5 2.6-3 1.7-6 3.5-9.1 5.2-2.4 1.4-4.8 2.8-7.3 4.2-.5.3-1 .6-1.6.9-.8.4-1.7.4-2.5-.1-2.2-1.3-4.5-2.6-6.7-3.9-2.1-1.2-4.2-2.5-6.3-3.7-1.6-.9-3.2-1.8-4.8-2.8-.8-.5-1.3-1.1-1.3-2.1V23.9zm14.5-.2c-.2.2-.4.3-.5.4l-5.5 5.5c-.6.6-.6 1.1 0 1.8.2.2.4.4.6.5.7.6 1.1.6 1.7-.1 2.4-2.4 4.8-4.8 7.3-7.2.8-.8.8-1.2 0-1.9l-7.1-7.1c-.1-.1-.2-.2-.4-.3-.5-.4-.9-.3-1.4.1-.2.2-.4.4-.7.6-.7.6-.7 1.1-.1 1.8L16 22c.7.5 1.3 1 1.9 1.7zM30 29.4h-6c-.7 0-1.1.4-1.1 1.1v1.1c0 .7.4 1 1 1H35.8c.8 0 1.2-.3 1.2-1.2v-.9c0-.8-.4-1.2-1.2-1.2-1.9.1-3.9.1-5.8.1z",
    style: {
      fill: "#daf5ec"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 23.7c-.7-.7-1.3-1.2-1.8-1.8l-4.2-4.2c-.7-.7-.6-1.2.1-1.8.2-.2.4-.4.7-.6.4-.4.9-.4 1.4-.1.1.1.3.2.4.3l7.1 7.1c.8.8.8 1.2 0 1.9-2.4 2.4-4.8 4.8-7.3 7.2-.6.6-1 .7-1.7.1-.2-.2-.4-.4-.6-.5-.7-.6-.7-1.1 0-1.8 1.8-1.9 3.7-3.7 5.5-5.5 0 0 .2-.1.4-.3zM30 29.4h5.8c.8 0 1.2.3 1.2 1.2v.9c0 .8-.4 1.2-1.2 1.2H23.9c-.6 0-1-.4-1-1v-1.1c0-.7.4-1.1 1.1-1.1 2-.1 4-.1 6-.1z",
    className: "st1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiServices);
export default __webpack_public_path__ + "static/media/api-services.6a1794f6e25c9ee2fd6a4927c658f59f.svg";
export { ForwardRef as ReactComponent };